/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S9_Li3Inputs */

const tr_mesafeli_s9_li3 = /** @type {(inputs: Mesafeli_S9_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, hassas veri kategorilerini (KVKK Madde 6) AI girdisi olarak kullanmaktan kaçınmakla yükümlüdür.`)
};

const en_mesafeli_s9_li3 = /** @type {(inputs: Mesafeli_S9_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer is obliged to refrain from using special categories of personal data (KVKK Article 6) as AI input.`)
};

const de_mesafeli_s9_li3 = /** @type {(inputs: Mesafeli_S9_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde ist verpflichtet, besondere Kategorien personenbezogener Daten (KVKK Artikel 6) nicht als AI-Eingabe zu verwenden.`)
};

const ru_mesafeli_s9_li3 = /** @type {(inputs: Mesafeli_S9_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клиент обязан воздерживаться от использования особых категорий персональных данных (статья 6 KVKK) в качестве входных данных для AI.`)
};

/**
* | output |
* | --- |
* | "The Customer is obliged to refrain from using special categories of personal data (KVKK Article 6) as AI input." |
*
* @param {Mesafeli_S9_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s9_li3 = /** @type {((inputs?: Mesafeli_S9_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S9_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s9_li3(inputs)
	if (locale === "de") return de_mesafeli_s9_li3(inputs)
	if (locale === "ru") return ru_mesafeli_s9_li3(inputs)
	return tr_mesafeli_s9_li3(inputs)
});